const linkLandingPagesValidationEN = {
    "add": {
        "title": {
            "required": "Title is required",
            "length": "Title can not be longer than 32 characters"
        },
        "short_description": {
            "length": "Description can not be longer than 80 characters."
        },
        "back_url": {
            "required": "Back Url is required",
            "length": "Back Url can not be longer than 10 characters",
            "unique": "Oops! This back url is already associated with another landing page. Please try another back url.",
            "available": "Back url is available",
            "invalid": "Back url is invalid"
        },
        "logo": {
            "required": "Logo is required",
            "dimensions": "Logo size has to be atleast 500 X 500 px and image 1:1 aspect ratio, JPG/JPEG/PNG formats supported.",
            "choose": "Please choose an image",
            "file": "Please Upload JPG or PNG formats, minimal resolution 500 X 500 px and image 1:1 aspect ratio. Max size 2MB"
        },
        "background_image": {
            "dimensions": "Background Image size has to be atleast 1000 X 1000 px and image 1:1 aspect ratio, JPG/JPEG/PNG formats supported.",
            "choose": "Please choose an image",
            "file": "Please Upload JPG or PNG formats, minimal resolution 1000 X 1000 px and image 1:1 aspect ratio. Max size 5MB"
        },
        "social_link_destination_url_facebook": {
            "required": "Destination Url is required",
            "regexp": "Invalid Url",
            "invalid": "Invalid Facebook Url"
        },
        "social_link_destination_url_instagram": {
            "required": "Destination Url is required",
            "regexp": "Invalid Url",
            "invalid": "Invalid Instagram Url"
        },
        "social_link_destination_url_twitter": {
            "required": "Destination Url is required",
            "regexp": "Invalid Url",
            "invalid": "Invalid Twitter Url"
        },
        "social_link_destination_url_youtube": {
            "required": "Destination Url is required",
            "regexp": "Invalid Url",
            "invalid": "Invalid Youtube Url"
        },
        "social_link_destination_url_tiktok": {
            "required": "Destination Url is required",
            "regexp": "Invalid Url",
            "invalid": "Invalid TikTok Url"
        },
        "social_link_destination_url_linkedin": {
            "required": "Destination Url is required",
            "regexp": "Invalid Url",
            "invalid": "Invalid LinkedIn Url"
        },
        "social_link_destination_url_other": {
            "regexp": "Invalid Url",
        },
        "featured_link_title": {
            "required": "Label is required",
            "length": "Label cannot exceed 100 characters"
        },
        "featured_link_destination_url": {
            "required": "Destination Url is required",
            "regexp": "Invalid Url",
        }
    },
    "update": {
        "title": {
            "required": "Title is required",
            "length": "Title can not be longer than 32 characters"
        },
        "short_description": {
            "length": "Description can not be longer than 80 characters."
        },
        "back_url": {
            "required": "Back Url is required",
            "length": "Back Url can not be longer than 10 characters",
            "unique": "Oops! This back url is already associated with another landing page. Please try another back url.",
            "available": "Back url is available",
            "invalid": "Back url is invalid"
        },
        "logo": {
            "required": "Logo is required",
            "dimensions": "Logo size has to be atleast 500 X 500 px and image 1:1 aspect ratio, JPG/JPEG/PNG formats supported.",
            "choose": "Please choose an image",
            "file": "Please Upload JPG or PNG formats, minimal resolution 500 X 500 px and image 1:1 aspect ratio. Max size 2MB"
        },
        "background_image": {
            "dimensions": "Background Image size has to be atleast 1000 X 1000 px and image 1:1 aspect ratio, JPG/JPEG/PNG formats supported.",
            "choose": "Please choose an image",
            "file": "Please Upload JPG or PNG formats, minimal resolution 1000 X 1000 px and image 1:1 aspect ratio. Max size 5MB"
        },
        "social_link_destination_url_facebook": {
            "required": "Destination Url is required",
            "regexp": "Invalid Url",
            "invalid": "Invalid Facebook Url"
        },
        "social_link_destination_url_instagram": {
            "required": "Destination Url is required",
            "regexp": "Invalid Url",
            "invalid": "Invalid Instagram Url"
        },
        "social_link_destination_url_twitter": {
            "required": "Destination Url is required",
            "regexp": "Invalid Url",
            "invalid": "Invalid Twitter Url"
        },
        "social_link_destination_url_youtube": {
            "required": "Destination Url is required",
            "regexp": "Invalid Url",
            "invalid": "Invalid Youtube Url"
        },
        "social_link_destination_url_tiktok": {
            "required": "Destination Url is required",
            "regexp": "Invalid Url",
            "invalid": "Invalid TikTok Url"
        },
        "social_link_destination_url_linkedin": {
            "required": "Destination Url is required",
            "regexp": "Invalid Url",
            "invalid": "Invalid LinkedIn Url"
        },
        "social_link_destination_url_other": {
            "regexp": "Invalid Url",
        },
        "featured_link_title": {
            "required": "Label is required",
            "length": "Label cannot exceed 100 characters"
        },
        "featured_link_destination_url": {
            "required": "Destination Url is required",
            "regexp": "Invalid Url",
        }
    },
};

export default linkLandingPagesValidationEN;